<template>
	<div class="panel panel-clinic">
		<div class="panel-heading collapsed" href="#form_log" data-toggle="collapse">
			<div class="arrow-down"></div>
			<h2 class="panel-title">Logg</h2>
		</div>

		<div id="form_log" class="panel-collapse collapse">
			<div class="panel-body">
				<div class="form-horizontal">

					<form-contact-log :clinic="clinic"></form-contact-log>

					<br><br>
					<h3>Datum för nästa kontakt</h3>

					<div class="list-group">
						<div class="list-group-item log-head">
							<div class="row">
								<div class="col-md-8">
									Nästa kontakt
								</div>
								<div class="col-md-8">
									Tillagd av
								</div>
								<div class="col-md-8">
									Tilldelad till
								</div>
								<div class="col-md-20">
									Kommentar
								</div>
							</div>
						</div>

						<div class="list-group-item log-item" v-for="entry in contactFiltered">
							<div class="row">
								<div class="col-md-8">
									{{ entry.date.substr(0, 10) }}
								</div>
								<div class="col-md-8">
                                    <span v-if="entry.admin">{{ entry.admin.name }}</span>
								</div>
								<div class="col-md-8">
									{{ entry.assigned_admin.name }}
								</div>
								<div class="col-md-20">
									{{ entry.comment }}
								</div>
								<div class="col-md-4">
									<div class="btn btn-xs btn-info" style="float:right;" v-on:click="edit(entry)">Ändra</div>
								</div>
								<div class="col-md-2">
									<div class="btn btn-xs btn-danger" style="float:right;" v-on:click="remove(entry.id)">-</div>
								</div>
							</div>
						</div>

						<div class="list-group-item log-add" v-bind:class="{ store : newContactEntry.mode == 'update'}">
							<div class="row">
								<div class="col-md-8">
									<datepicker
										:format="dateFormat"
										v-model="newContactEntry.date"
										language="sv"
										input-class="form-control"
										:monday-first="true">
									</datepicker>
								</div>
								<div class="col-md-8">
									{{ user_name }}
								</div>
								<div class="col-md-8">
									<select class="form-control" v-model="newContactEntry.assigned_admin_id">
										<option v-for="user in users" v-bind:value="user.id">{{ user.name }}</option>
									</select>

                                    <div style="margin-top: 10px;" v-if="newContactEntry.assigned_admin_id === user_id">
                                        Skicka epost <input type="checkbox" v-model="newContactEntry.send_email_to_self" />
                                    </div>
								</div>
								<div class="col-md-20">
									<textarea class="form-control" style="height: 80px;" v-model="newContactEntry.comment"></textarea>
								</div>
								<div class="col-md-6">
									<div class="btn btn-default" style="float:right;" v-on:click="store('contact')" v-if="newContactEntry.mode == 'store'">
										Lägg till
									</div>
									<div class="btn btn-xs btn-default" style="float:right; margin-left:10px;" v-on:click="update('contact')" v-if="newContactEntry.mode == 'update'">
										Spara
									</div>
									<div class="btn btn-xs btn-info" style="float:right;" v-on:click="abort('contact')" v-if="newContactEntry.mode == 'update'">
										Avbryt
									</div>
								</div>
							</div>
						</div>
					</div>

					<br><br>
					<div class="form-group oddevencol">
						<label class="col-md-14 control-label">Intern information</label>
						<div class="col-md-36">
							<textarea class="form-control" style="height: 300px;" v-model="clinic.internal_information"></textarea>
						</div>
					</div>

					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						type="text_old_prospect_status"
						layout="textBox"
						title="Gammal prospektstatus (tidigare i namnfältet)">
					</row-meta>

				</div>
			</div>
		</div>
	</div>
</template>

<script>

import mixin from './mixin'
import FormContactLog from './contact-log/index.vue'

export default {

    components: {
        FormContactLog
    },

    mixins: [mixin],

	    data () {
      		return {

      			user_name: user_name,
      			user_id: user_id,

      			newLogEntry: {
      				id: null,
      				mode: 'store',
      				date: new Date(),
      				comment: '',
      				assigned_admin_id: user_id,
                send_email_to_self: false,
      				saving: false
      			},
      			logLimit: 5,

      			newContactEntry: {
      				id: null,
      				mode: 'store',
      				date: new Date(),
      				comment: '',
      				assigned_admin_id: user_id,
                send_email_to_self: false,
      				saving: false
      			},

      			dateFormat: 'yyyy-MM-dd'

      		}
	    },

	    computed: {

	    	logFiltered () {
	    		return _.orderBy(this.clinic.log, ['date'], ['desc'])
	    	},

	    	contactFiltered () {
	    		return _.orderBy(this.clinic.log_contact, ['date'], ['desc'])
	    	},

	    	logCanShowMore () {
	    		if (this.logFiltered.length < this.clinic.log.length) {
	    			return true
	    		}

	    		return false
	    	}

	    },

	    methods: {

	    	dateIsPast (date) {
	    		if (moment(date) < moment()) {
	    			return true
	    		}

	    		return false
	    	},

	    	edit (entry) {
	    		if (entry.type != 'contact') {
	    			return
	    		}

	    		this.newContactEntry = {
	    			id: entry.id,
	    			mode: 'update',
      				date: new Date(entry.date),
      				comment: entry.comment,
      				assigned_admin_id: entry.assigned_admin_id,
                send_email_to_self: false,
      				saving: false
      			}
	    	},

	    	abort (type) {
	    		this.resetEntry(this.newContactEntry)
	    	},

	    	resetEntry (entry) {
	    		entry.mode = 'store'
		        entry.id = null
		        entry.assigned_admin_id = user_id
            entry.send_email_to_self = false
		        entry.date = new Date()
		        entry.comment = ''
		        entry.saving = false
	    	},

	    	store (type) {
	    		const self = this

	    		if (type == 'log') {
	    			var entry = self.newLogEntry
	    		}

	    		if (type == 'contact') {
	    			var entry = self.newContactEntry
	    		}

	    		if (entry.saving || (type == 'log' && !entry.comment)) {
	    			console.log('prevent saving twice')
	    			return
	    		}

	    		entry.saving = true

	    		console.log('storeLogEntry')
	    		console.log(entry)

	    		self.$http.post(
                '/clinics/' + self.clinic.id + '/storeLogEntry',
                {
                    type: type,
                    assigned_admin_id: entry.assigned_admin_id,
                    send_email_to_self: entry.send_email_to_self,
                    date: moment(entry.date).format('YYYY-MM-DD'),
                    comment: entry.comment
                }
            )
                .then((response) => {
			        console.log('response')
			        console.log(response.data)

			        self.resetEntry(entry)

			        self.clinic.log = response.data.log
			        self.clinic.log_contact = response.data.log_contact

			        bus.$emit('notify', 'Inlägget sparades.')
                }, (response) => {
		        	console.log(JSON.stringify(response))
		   		})
	    	},

	    	update (type) {
	    		const self = this

	    		if (type == 'contact') {
	    			var entry = self.newContactEntry
	    		}

	    		if (entry.saving || (type == 'log' && !entry.comment)) {
	    			console.log('prevent saving twice')
	    			return
	    		}

	    		entry.saving = true

	    		console.log('updateLogEntry')
	    		console.log(entry)

	    		self.$http.post(
                '/clinics/' + self.clinic.id + '/updateLogEntry',
                {
                    log_id: entry.id,
                    type: type,
                    assigned_admin_id: entry.assigned_admin_id,
                    send_email_to_self: entry.send_email_to_self,
                    date: moment(entry.date).format('YYYY-MM-DD'),
                    comment: entry.comment
                }
            )
                .then((response) => {
			        console.log('response')
			        console.log(response.data)

			        self.resetEntry(entry)

			        self.clinic.log = response.data.log
			        self.clinic.log_contact = response.data.log_contact

			        bus.$emit('notify', 'Inlägget uppdaterades.')
                }, (response) => {
		        	console.log(JSON.stringify(response))
		   		})
	    	},

	    	remove (log_id) {
	    		const self = this

	    		if (!confirm('Är du säker')) {
	    			return
	    		}

	    		self.$http.post(
                '/clinics/' + self.clinic.id + '/deleteLogEntry',
                {
                    log_id: log_id
                }
            )
                .then((response) => {
			        console.log('deleteLogEntry response')
			        console.log(response.data)

			        self.clinic.log = response.data.log
			        self.clinic.log_contact = response.data.log_contact

			        bus.$emit('notify', 'Inlägget raderades.')
                }, (response) => {
		        	console.log(JSON.stringify(response))
		   		})
	    	}

	    }

}

</script>
